import React from 'react'
import Button from 'components/Button'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'
import { PhoneSystemDidNumbersAvailableTable } from '../../PhoneSystemDidNumbersAvailableTable/'
import { Field } from 'redux-form'
import { IPhoneSystemFormData } from '../PhoneSystemForm.container'

export interface ISelectDidNumbersStepProps {
  prev: Function
  formData: IPhoneSystemFormData
  setHeadings?: Function
}

export const SelectDidNumbersStep = (props: ISelectDidNumbersStepProps) => {
  const { prev, formData, setHeadings } = props
  const count = formData.didNumbers?.length || 0
  const required = formData.plan?.maxDIDNumbers || 0

  setHeadings &&
    setHeadings({
      heading: 'Now we add some Seasoning to this Dill',
      subHeading: 'Your DID Number is the number used in the system internally',
    })

  return (
    <div>
      <div className={cn(sText.descrip3, sMarg.mb30)}>
        Don't worry you'll be able to add your 1300/1800 Virtual Business number to your All In One
        PBX Phone System later. Here we just need you to select one number from the list below. You
        must select {required} {required === 1 ? 'number' : 'numbers'}.
      </div>
      <div className={cn(sText.descrip2, sMarg.mb30)}>
        {count} / {required} {required === 1 ? 'number' : 'numbers'} selected.
      </div>
      <Field
        name="didNumbers"
        component={PhoneSystemDidNumbersAvailableTable}
        maxDIDNumbers={formData.plan?.maxDIDNumbers}
      />
      <div
        className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
        style={{ marginTop: '40px' }}
      >
        <Button color="tertiary" type="submit" disabled={count !== required}>
          Next
        </Button>
        <br />
        <br />
        <Button plain onClick={prev}>
          Back
        </Button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemForm/SelectDidNumbersStep/SelectDidNumbersStep.tsx